import { adoptionStatusModelData } from './models/AdoptionStatusesModel'
import { AdminAdoptionStatusService } from './api/AdminAdoptionStatusService'

const AdoptionStatusModule = {
  namespaced: true,
  state: adoptionStatusModelData(),
  getters: {
    fetchAdoptionStatusList: state => state.adoptionStatusList
  },
  mutations: {
    setAdoptionStatusList (state, data) {
      state.adoptionStatusList = data.list
    }
  },
  actions: {
    /**
     * Get code year list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getAdoptionStatusList ({ commit }, { resolve, reject, status = '' }) {
      try {
        const response = await AdminAdoptionStatusService.fetchAdoptionStatusList(status)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdoptionStatusList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default AdoptionStatusModule
